enum AccessReportsAdminAddProductStepEnum {
  ProductDetails = "Product Details",
  Specialties = "Specialties",
  PageOptions = "Page Options",
}

export { AccessReportsAdminAddProductStepEnum };
